module.exports = __webpack_public_path__ + "media/images/login/login_mid-414db32b9348fe43f36e2a04be05145f.gif";